import "reflect-metadata";
import ReactDOM from "react-dom";
import { App } from "./app";
import "./tailwind.css";

ReactDOM.render(<App />, document.getElementById("root"));
